import { render, staticRenderFns } from "./RegistrationFieldTos.vue?vue&type=template&id=525ab9d2&lang=pug&"
import script from "./RegistrationFieldTos.vue?vue&type=script&lang=ts&"
export * from "./RegistrationFieldTos.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationFieldTos.vue?vue&type=style&index=0&id=525ab9d2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports